const data = [
  {
    id: 1,
    name: "Alex De Souza",
    image:
      "https://store.donanimhaber.com/18/64/47/1864473ab68a30c3f5132d38a891cb16.jpg",
    stats: "245 Maç / 136 Gol",
    desc: "2004-12 | Fenerbahçe'nin simgesi haline gelen Alex, 2004'te sırtına geçirdiği Fenerbahçe formasını 8 sene terletti. 245 maçta 136 gol kaydeden efsane futbolcu, 3 lig şampiyonluğu, 2 Süper Kupa ve 1 kez de Türkiye Kupası kazandı.",
  },
  {
    id: 2,
    name: "Pierre Van Hooijdonk",
    image:
      "https://img.fanatik.com.tr/img/78/740x418/602d6a0c66a97c8af8db08db.jpg",
    stats: "53 Maç / 32 Gol",
    desc: "2003-05 | 2 sezon Fenerbahçe forması giyen Van Hooijdonk, 53 maçta 32 gol kaydedip 2 şampiyonluk yaşadı.",
  },
  {
    id: 3,
    name: "Tuncay Şanlı",
    image:
      "https://i.pinimg.com/originals/13/fa/de/13fade421e4d8887d9fe34cb07263662.jpg",
    stats: "154 Maç / 59 Gol",
    desc: " 2002-07 | 5 yıl geçirdiği Fenerbahçe'de taraftarın sevgilisi olan Tuncay, 154 maçta 59 gol kaydederken 3 kez de şampiyonluk yaşadı.",
  },
  {
    id: 4,
    name: "Gökhan Gönül",
    image:
      "https://cdnuploads.aa.com.tr/uploads/Contents/2016/06/10/thumbs_b_c_94d3cbb769b7a44816ad6b50894223f3.jpg",
    stats: "365 Maç / 14 Gol",
    desc: "2007-2016 / 2020-2021 | 2007'de Gençlerbirliği Oftaş'tan Fenerbahçe'ye transfer olan Gökhan Gönül, ülke tarihinin en iyi sağ beklerinden biri olarak görülüyor. Yıldız futbolcu, sarı-lacivertli ekiple 9 senede 2 lig şampiyonluğu 2 Türkiye Kupası ve 3 Türkiye Süper Kupası kazandı.",
  },
  {
    id: 5,
    name: "Volkan Demirel",
    image:
      "https://img.fanatik.com.tr/img/78/700x0/5b0d31f8ae298b43d3271398.jpg",
    stats: "523 Maç / 0 Gol",
    desc: " 2001-2019 | 16 sene Fenerbahçe forması giyen Volkan, Fenerbahçe ile adeta özdeşleşti. 300'ün üzerinde maça çıkan tecrübeli filebekçisi, 5 şampiyonluk ve 2 kupa zaferi yaşadı. Deneyimli kaleci, Kadıköy'de Galatasaray, Beşiktaş ve Trabzonspor'a karşı hiç yenilgi görmeden kariyerini sonlandırdı.",
  },
  {
    id: 6,
    name: "Jay Jay Okocha",
    image:
      "https://img.fanatik.com.tr/img/78/700x0/5b0d31f8ae298b43d2f78429.jpg",
    stats: "63 Maç / 30 Gol",
    desc: "1996-98 | 2 sezon Fenerbahçe forması giyen ve dönemin en popüler futbolcularından olan Okocha, 63 maçta 30 gol kaydetti ve daha sonra PSG'ye transfer oldu.",
  },
  {
    id: 7,
    name: "Harald Schumacher",
    image:
      "https://img.fanatik.com.tr/img/78/700x0/5b0d31f966a97c43510ab841.jpg",
    stats: "89 Maç / 0 Gol",
    desc: "1988-91 | Dünyaca ünlü Alman kaleci Schumacher, 1988'de Fenerbahçe'ye transfer oldu. 3 sene Fenerbahçe'de top koşturan efsane, 1 kez şampiyonluk yaşadı.",
  },
  {
    id: 8,
    name: "Uche Okechukwu",
    image:
      "https://i.pinimg.com/originals/52/5c/95/525c95b999b8a01fb34aff288c72806b.jpg",
    stats: "191 Maç / 19 Gol",
    desc: "1993-02 | 1993'te transfer olduğu Fenerbahçe'de 9 sene top koşturan Uche, 191 maçta 19 gol kaydetti ve 4 kez de şampiyonluk yaşadı.",
  },
  {
    id: 9,
    name: "Rüştü reçber",
    image:
      "https://www.futbolkulturu.com/wp-content/uploads/2020/06/Efsane-Kaleci-R%C3%BC%C5%9Ft%C3%BC-Re%C3%A7ber%E2%80%99in-Hikayesi0-e1592995335870.jpg",
    stats: "295 Maç / 0 Gol",
    desc: " 1994-03 / 2004-07 | Türk futbolunun yetiştirdiği en önemli kalecilerden olan Rüştü, iki dönem Fenerbahçe forması giydi, 295 maça çıktı ve 4 şampiyonluk gördü.",
  },
  {
    id: 10,
    name: "Oğuz Çetin",
    image:
      "https://img.fanatik.com.tr/img/78/700x0/5b0d31fb66a97c4350d370b6.jpg",
    stats: "274 Maç / 47 Gol",
    desc: "1988-96 | 8 sene Fenerbahçe forması giyen oyun kurucu Oğuz Çetin, 274 maçta 47 gol kaydetti ve 2 kez de şampiyonluk yaşadı.",
  },
  {
    id: 11,
    name: "Rıdvan Dilmen",
    image:
      "https://img.fanatik.com.tr/img/78/700x0/5b0d31fbae298b43d32713a2.jpg",
    stats: "108 Maç / 32 Gol",
    desc: "1987-95 | 'Şeytan' lakabıyla ve hızıyla bilinen Rıdvan Dilmen, Fenerbahçe'de 8 sene top koşturdu ancak ağır sakatlıklarından ötürü futbolu 33 yaşında bıraktı.",
  },
  {
    id: 12,
    name: "Selçuk Yula",
    image:
      "https://img.fanatik.com.tr/img/78/700x0/5b0d31fb66a97c43510ab853.jpg",
    stats: "304 Maç / 134 Gol",
    desc: "1979-86 | Fenerbahçe formasını 7 sene taşıyan Selçuk Yula, sarı-lacivertlilerde 304 maçta 134 gol kaydetti ve 2 kez üst üste gol kralı oldu.",
  },
  {
    id: 13,
    name: "Atkut Kocaman",
    image:
      "https://img.fanatik.com.tr/img/78/700x0/5b0d31fc66a97c4350d370c0.jpg",
    stats: "215 Maç / 140 Gol",
    desc: "1988-96 | 8 sene Fenerbahçe forması giyen Aykut Kocaman, takımıyla 215 maçta 140 gol kaydetti, 2 şampiyonluk yaşadı ve 3 kez gol kralı oldu.",
  },
  {
    id: 14,
    name: "Cemil Turan",
    image:
      "https://img.fanatik.com.tr/img/78/700x0/5b0d31fcae298b43cc1af49d.jpg",
    stats: "366 Maç / 194 Gol",
    desc: "1972-80 | Fenerbahçe'de 8 sene oynayan Cemil, 366 maçta 194 gol attı. Türk futbolunun en golcü oyuncularından birisi olan Cemil Turan; futbol tekniği, ani deparları ve sıyrılışları, demarke kalmasındaki başarısı ve topu kullanışı ile Türk futbolunun gelmiş geçmiş en iyi futbolculardan sayılır.",
  },
  {
    id: 15,
    name: "Basri Dirimlili",
    image:
      "https://img.fanatik.com.tr/img/78/700x0/5b0d31fd66a97c4350d370c6.jpg",
    stats: "178 Maç / 7 Gol",
    desc: "1953-63 | 10 sene Fenerbahçe forması giyen Basri Dirimlili, Adana Demirspor'la yapılan özel bir maçta, çene kemiğinin kırılmasına rağmen sahada kalmaya devam etmişliğinden dolayı kendisine 'Mehmetçik' lakabı verilmiştir.",
  },
  {
    id: 16,
    name: "Fikret Kırcan",
    image:
      "https://img.fanatik.com.tr/img/78/700x0/5b0d31fe66a97c43510ab85b.jpg",
    stats: "419 Maç / 139 Gol",
    desc: "1933-56 | 22 sene Fenerbahçe forması giyen Fikret Kırcan, Fenerbahçe kulüp tarihinin en uzun süre formasını giyen oyuncu olma özelliğine sahip. Fikret Kırcan, Fenerbahçe formasıyla 419 maçta 139 gol kaydetti.",
  },
  {
    id: 17,
    name: "Zeki Rıza Sporel",
    image:
      "https://img.fanatik.com.tr/img/78/700x0/5b0d31feae298b43cd1bfe82.jpg",
    stats: "352 Maç / 470 Gol",
    desc: "1916-34 | Fenerbahçe formasıyla 352 maçta 470 gol atan Zeki Rıza, aynı zamanda Milli Takım'ın da ilk golcüsüdür. Zeki Rıza, daha sonra Fenerbahçe başkanlığı da yaptı.",
  },
  {
    id: 18,
    name: "Cihat Arman",
    image:
      "https://img.fanatik.com.tr/img/78/700x0/5b0d31ffae298b43cd1bfe84.jpg",
    stats: "309 Maç / 0 Gol",
    desc: "1939-51 | Fenerbahçe formasını 309 kez giyen 'Uçan Kaleci' lakaplı Cihat Arman, Türk futbolunun ve Fenerbahçe'nin gelmiş geçmiş en iyi kalecilerinden biri olarak görülmektedir. Ayrıca Arman, Giydiği sarı forma sebebiyle Fenerbahçe'nin kanarya sembolünü almasını sağladı",
  },
  {
    id: 19,
    name: "Can Bartu",
    image:
      "https://img.fanatik.com.tr/img/78/700x0/5b0d31ff66a97c43510ab863.jpg",
    stats: "372 Maç / 181 Gol",
    desc: "1955-61 / 1967-70 | Futbola Fenerbahçe'de başlayıp daha sonra 6 senelik Avrupa macerasına atılan Can Bartu, 1967'de tekrar Fenerbahçe'ye geldi ve futbolu burada bıraktı. Efsane golcü, sarı-lacivertlilerde 372 maçta 181 gol attı.",
  },
  {
    id: 20,
    name: "Lefter Küçükandonyadis",
    image:
      "https://img.fanatik.com.tr/img/78/700x0/5b0d31ffae298b43cc1af4a5.jpg",
    stats: "615 Maç / 423 Gol",
    desc: "1947-51 / 1953-64 | 2 dönem Fenerbahçe forması giyen Lefter, Fenerbahçe'de oynadığı 615 maçta 423 gol kaydetti.",
  },
];

export default data;
